import { updateTimeline } from "@/mocks/home";

export default function UpdateTimeline() {
  return (
    <section id="today" className="border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              Today Timeline
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日更新节奏表
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
              六个节点按时间顺序排开，每个点位写清楚更新什么、值不值得专门蹲。状态实时标记，已发布的直接点进去补课。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3.5 py-2 text-xs font-medium text-secondary-800">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-time-line"></i>
            </span>
            当前进度 3 / 6 已发布
          </span>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {updateTimeline.map((item, index) => {
            const published = item.status === "published";
            return (
              <li
                key={item.id}
                className={`group relative rounded-lg border p-5 transition-colors ${
                  published
                    ? "border-background-200 bg-background-50 hover:border-secondary-300"
                    : "border-background-300/70 bg-background-50/70 hover:border-primary-300"
                }`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-8 w-8 items-center justify-center rounded-md text-xs font-bold tabular-nums ${
                      published
                        ? "bg-secondary-100 text-secondary-800"
                        : "bg-primary-500 text-background-50 dark:text-foreground-950"
                    }`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span
                    className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${
                      published ? "bg-secondary-100 text-secondary-800" : "bg-accent-100 text-accent-900"
                    }`}
                  >
                    {published ? "已发布" : "待更新"}
                  </span>
                </div>

                <div className="mt-4 flex items-baseline gap-2">
                  <span className="font-heading text-2xl font-bold tabular-nums text-foreground-950">
                    {item.time}
                  </span>
                  <span className="rounded-sm bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600">
                    {item.tag}
                  </span>
                </div>

                <h3 className="mt-3 text-sm font-bold text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-xs leading-6 text-foreground-500">{item.desc}</p>

                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5">
                  <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-fire-line text-primary-500"></i>
                    </span>
                    热度 {item.heat}
                  </span>
                  <span
                    className={`flex items-center gap-1 text-[11px] font-medium ${
                      published ? "cursor-pointer text-primary-600" : "text-foreground-400"
                    }`}
                  >
                    {published ? "查看内容" : "设置提醒"}
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className={published ? "ri-arrow-right-line" : "ri-notification-3-line"}></i>
                    </span>
                  </span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}